/* eslint-disable no-template-curly-in-string */
export default {
  slip: {
    cancelled: 'Cancelled',
    voidedUnmatched: 'No match found',
    picks__hasPlural: {
      one: '1 pick',
      other: '{{count}} picks',
    },
    picksContestTitle: '{{count}}-pick contest',
    waitingForMatch: 'Waiting for match',
    partiallyMatched: 'Partially matched',
    win: 'Win',
    winUpTo: 'Win up to',
    goPerfect: 'Go perfect',
    protectedPayout: 'Perfect Score',
    maxPayout: 'Top Score',
    won: 'Won',
    refunded: 'Refunded',
    cancelledAndRefunded: 'Cancelled & Refunded',
    voided: 'Voided',
    splitSlipChildrenCount: 'Split Entry ({{count}})',
    splitSlipTag: 'Split ({{number}})',
    placeSlipTag: '{{place}} place',
    placeSlipTagTied: 'T-{{place}}',
    splitSlipCopy: {
      contests__hasPlural: {
        one: 'This entry was split into {{count}} contest.',
        other: 'This entry was split into {{count}} contests.',
      },
      refunded: ' ${{amount}} was not matched & has been refunded.',
      remaining: ' remaining',
    },
    copySlipId: {
      success: 'Slip ID copied!',
      error: 'Could not copy slip ID.',
    },
    more: 'More',
    less: 'Less',
    standingsHeader: {
      rank: '#',
      player: 'Player',
      entry: 'Entry',
      score: 'SCORE',
      winnings: 'Winnings',
    },
    standingsEntry: {
      winner: 'Winner',
      currentlyViewing: 'Currently viewing this entry',
      scoreRankDivergence: 'Entries with no missed picks rank above all other entries.',
      howScoringWorks: 'How scoring works',
    },
  },
  slips: {
    empty: {
      browsePlayers: 'Browse players',
      active: {
        title: 'No active entries',
        subtitle: 'Browse players to make picks and submit entries.',
      },
      final: {
        title: 'No final entries',
        subtitle:
          "When your active entries finalize, they'll appear here. Browse players to make picks and submit entries.",
      },
    },
  },
  slipDetail: {
    nav: {
      standings: 'Standings',
      myPicks: 'My Picks',
      detail: 'Details',
    },
    header: {
      currentPlace: 'Current place',
      finalPlace: 'Final place',
      inTheHunt: 'In the hunt',
    },
    pages: {
      standings: 'Standings',
      myPicks: 'My Picks',
    },
    potPointsAbbr: 'Pot. pts',
    eliminated: 'Eliminated',
    lookingForMatchBanner: {
      title: 'Looking for match...',
      subtitle: 'Your opponents and their picks will show when the contest has filled.',
    },
    errorLoadingPicks: 'Failed to load picks',
    propSections: {
      alternate: 'Alternate',
      inactive: 'Inactive',
      alternateDescription:
        'Alternate will replace an inactive primary player. The swap occurs after a primary player has been designated as a DNP.',
      inactiveDescription: 'Replaced by alternate because player did not play.',
      learnMore: 'Learn more',
    },
    compare: 'Compare picks',
    compareTitle: 'Pick Comparison',
    compareNotEnoughSlips: 'You need at least 2 entries to compare',
    close: 'Close',
    matchedBanner: {
      title: 'Matched - {{percent}}% full',
      subtitle: 'Your opponents and their picks will show when the contest has filled.',
      footer: '{{entryCount}}/{{maxEntries}} entrants found',
    },
    userCancelledBanner: {
      title: 'Entry refunded',
      subtitle: 'You cancelled this entry. We have refunded your entry fee.',
    },
    voidedUnmatchedBanner: {
      title: 'Entry refunded',
      subtitle:
        'We were unable to match your entry into a contest and have refunded your entry fee.',
    },
    voidedByCSBanner: {
      title: 'Entry refunded',
      subtitle:
        'Your entry has been refunded. The full entry fee has been credited back to your account.',
      viewCancellationRules: 'View all cancellation rules.',
    },
    contestResizedBanner: {
      title: 'Contest resized!',
      subtitle__hasPlural: {
        one: 'It’s your lucky day! To expedite matching, we’ve added {{count}} free slot to your contest giving you a better chance to win. Fewer opponents but the same guaranteed prizes.',
        other:
          'It’s your lucky day! To expedite matching, we’ve added {{count}} free slots to your contest giving you a better chance to win. Fewer opponents but the same guaranteed prizes.',
      },
    },
    earlyPayoutBanner: {
      protectedWon: {
        title: 'Congrats on the guaranteed payout!',
        subtitle: 'All of your protected payout picks were correct!',
      },
      perfectWon: {
        title: 'Congrats on the guaranteed payout!',
        subtitle: 'All of your picks were correct!',
      },
      nonProtectedWon: {
        title: 'Congrats! You won!',
        subtitle: 'You clinched 1st place. The contest is now final.',
      },
      lost: {
        title: 'Contest is now final',
        subtitle: 'Another entry has already clinched 1st place.',
      },
    },
    splitEntryBanner: {
      title: 'Split Entry',
      subtitle__hasPlural: {
        one: 'Your entry has been split into <strong>1 contest</strong>. ',
        other: 'Your entry has been split into <strong>{{count}} contests</strong>. ',
      },
      remainingAmount:
        'There is still <strong>${{amount}} remaining</strong> of your original entry that is waiting to be matched.',
      refundedAmount:
        '<strong>${{amount}} of your original entry</strong> was not matched and has been refunded.',
    },
    detail: {
      entryFee: 'Entry fee',
      prize: 'Prizes',
      payout: 'Payout',
      scoring: {
        push: 'Push',
        correct: 'Correct',
        incorrect: 'Incorrect',
        dnp: 'DNP',
      },
      points__hasPlural: {
        one: '{{count}} point',
        other: '{{count}} points',
      },
      sections: {
        prize: {
          title: 'Prize payouts',
          resizingMode: {
            guaranteed: 'Guaranteed',
            guaranteedProp:
              'Once matched into a contest, the payout amounts will not change if the contest doesn’t fill.',
          },
        },
        detail: 'Details',
        rules: 'Scoring & Rules',
        entrants: {
          title: 'Entrants',
          waiting: 'Your opponents will show when matched.',
          error: 'There was an error loading the entrants.',
          noData: 'No entrants found.',
          retry: 'Retry',
        },
      },
      myPicks: {
        title: 'My Picks',
        result: 'Result',
      },
    },
    entry: {
      title: 'Entry details',
      boostedWinnings: '{{amount}} + {{boostAmount}} in boosted winnings',
      noData: {
        title: 'Not found',
        description:
          'The entry you are looking for does not exist. Please check the URL and try again.',
      },
      prop: {
        game: {
          status: {
            live: 'Live',
            final: 'Final',
          },
        },
        status: {
          dnp: 'DNP',
          alternate: 'ALT',
        },
      },
    },
    dropdown: {
      cancelSlip: 'Cancel entry',
    },
    modal: {
      slipCancellation: {
        title: 'Cancel entry within {{remainingTime}}',
        description:
          'Do you want to cancel your entry? The entry fee will refunded and returned to your balance.',
        cancel: 'Not now',
        submit: 'Confirm',
        error: 'An error occurred while canceling the entry. Please try again later.',
        success: 'The entry has been successfully canceled.',
      },
    },
  },
  title: 'QuickPicks',
  myEntries: 'My Entries',
  tabs: {
    board: 'Board',
    active: 'Active',
    final: 'Final',
  },
  popularPage: {
    title: 'Popular Picks',
    closeToBoardAriaLabel: 'Return to Browse',
  },
  board: {
    oddsNote: 'Above 50% lowers your total multiplier, below 50% raises it',
    picksPanel: {
      viewEntry: 'View entry',
      confirmAlternate: 'Confirm',
      selectAlternatePick: 'Select alternate pick',
      winUpTo: 'Win up to {{payoutMultiplier}}x',
      minPicksRequired: '{{count}} picks required',
      addAtLeastAmountOfPicks: 'Add at least {{count}} picks',
    },
    picksDrawer: {
      alternate: {
        divider: 'ALTERNATE PICK',
        required: 'Alternate pick required',
        select: 'Select',
        confirm: 'Confirm alternate',
        cancel: 'Cancel',
        selectFromList: 'Select alternate pick from the list',
      },
      errors: {
        minPicks: 'You must select at least {{count}} picks',
        atLeastTwoTeam: 'Your picks must include players from at least 2 teams.',
        invalidSlipLengthPromoApplied: 'Boost must be used on a {{count}} pick entry',
        invalidBetOptionPromoApplied: 'Boost must be used on a {{amount}} entry',
        apiError: {
          title: 'Submission failed',
        },
        maxPayoutNotAllowed: {
          title: 'Top Score not available',
          message: 'These picks are too correlated. Please use Perfect Score to submit your entry.',
        },
        multiplierChanged: {
          title: 'Perfect Score multiplier updated',
          message:
            'The Perfect Score multiplier has been updated from {{previousMultiplier}}x to {{newMultiplier}}x. Please try again.',
        },
        locationError:
          'Based on your current location, you are not currently allowed to enter this contest.',
        kycError: 'Please verify your information before entering a contest.',
        entryLimitReached: {
          title: 'Entry limit reached',
          message:
            'You have hit the entry limit for QuickPicks entries. Please try submitting again later.',
          close: 'Ok',
        },
        boostValidation: {
          title: 'Boost validation failed',
          message: 'The selected boost cannot be applied to this entry. Please try again.',
        },
        voucherValidation: {
          title: 'Voucher validation failed',
          message: 'The selected voucher cannot be applied to this entry. Please try again.',
        },
      },
      close: 'Close',
      title: 'Review',
      actionsPanel: {
        selectEntryFee: 'Select an entry fee',
        entryAmountLabel: 'Entry amount',
        freeForm: {
          promotions: 'Promotions',
          removePromotion: 'Remove promotion',
          payWithCash: 'Cash:',
          payWithCredits: 'Credits:',
          changePayWith: 'Change payment method',
          win: 'Win {{multiplier}}x',
          winWithPayout: 'Win {{multiplier}}x: {{payout}}',
          perfectScoreInfo: 'About Perfect Score',
          entriesUnavailable: 'Entries are currently unavailable for {{count}} picks',
          promoUnavailable: "This promo can't be used on a {{count}}-pick entry",
          promoConflict: {
            perfectScore: 'This promotion cannot be used with Perfect Score',
            credits: 'Promotions cannot be used with credits',
          },
          banner: {
            centsRemoved: 'Whole dollars only. Cents were removed.',
            slipMax: 'Max {{count}}-pick entry is {{max}}',
            cashBalanceMax: 'Max entry with your Cash balance is {{max}}',
            creditsBalanceMax: 'Max entry with your Credits balance is {{max}}',
            promoMax: 'Max entry with this promo is {{max}}',
          },
          promotionsSheet: {
            description: 'Showing promotions you can use for QuickPicks',
            close: 'Close',
          },
          payWithSheet: {
            title: 'Pay with',
            cash: 'Cash',
            credits: 'Credits',
            creditsUnavailableWithPromo: 'Not available when promos are applied',
            confirm: 'Confirm',
            close: 'Close',
          },
        },
        winUpTo: 'Win up to:',
        payout: 'Payout',
        maxPayout: 'Top Score',
        protectedPayout: 'Perfect Score',
        splitEntryEligible: 'Split Entry eligible',
        footNote:
          'This is a peer-to-peer contest. You will compete against other Splash users to score the most points. Your entry may be split into multiple contests based on matching availability.',
        footNoteV2:
          'This is a peer-to-peer contest. You will compete against other Splash users to score the most points.',
        footNoteInfoTooltip:
          'This is the guaranteed prize awarded to the entrant who scores the most points in your contest. If multiple entrants in your contest tie this prize will be split evenly across all winners.',
        footNoteRulesLink: 'Learn more',
        cashBalance: 'Cash Balance:',
        balanceError: 'There was an error while loading your account balance',
        viewAllLabel: 'Add More Picks',
        submitLabel: {
          signInToEnter: 'Sign in to submit entry',
          default: 'Submit entry',
          submitting: 'Submitting...',
          balanceError: 'Balance error',
          balanceInsufficient: 'Deposit to submit entry',
          boostInvalid: 'Boost invalid',
          voucherInvalid: 'Voucher invalid',
        },
        submitSubtitle: {
          feeWithVoucherApplied: 'FREE with voucher applied',
          validating: 'Validating voucher...',
        },
        voucherAppliedBanner: 'Voucher applied for entries up to ${{amount}}',
      },
    },
    entryChangedAlert: {
      title: 'Picks updated',
      text: 'Your projected stats were updated or removed. After confirming, you can view your updated selections.',
      submit: 'Confirm & Continue',
      removed: 'Removed',
    },
    payoutChangedAlert: {
      title: 'Payout multiplier updated',
      text: 'Your picks stay the same, but the multiplier changed. Please confirm before continuing.',
      submit: 'Confirm & Continue',
    },
    picksAndPayoutChangedAlert: {
      title: 'Picks and payout multiplier updated',
      text: 'Your projected stats and payout multiplier were updated or removed. After confirming, you can view your updated selections.',
      submit: 'Confirm & Continue',
    },
    tooManyInjuredPlayersModal: {
      title: 'Only one injured player allowed',
      body: "You've selected two injured players. Pick the one you want to keep in this entry.",
      confirm: 'Confirm',
    },
    alternateRequiredPrompt: {
      title: 'Add alternate pick',
      body: 'Your entry contains an injured player and requires an alternate to be selected. If the player does not play your alternate will be swapped in.',
      selectAlternate: 'Select alternate',
      close: 'Close',
    },
    alternateInjuredPrompt: {
      title: 'Add alternate pick',
      body: 'Your alternate pick is injured. Select a new alternate to keep your entry valid.',
      selectAlternate: 'Select alternate',
      dismiss: 'Dismiss',
    },
    alternateRemovedToast: {
      title: 'Alternate pick removed',
      message: 'Not required anymore',
    },
    entrySubmitted: {
      title: 'Entry submitted',
      subtitle:
        'Your entry has been submitted. It will be matched into a {{groupSize}}-entry, winner-take-all contest.',
      subtitleV2:
        'Your entry has been submitted. It will be matched into a {{groupSize}}-entry contest.',
      picksCount: '{{count}} picks',
      winUpTo: 'Win up to:',
      protectedPayout: 'Perfect Score',
      picksReuse: 'Reuse picks',
      close: 'Close',
      boostApplied: '{{selectedBoost}} applied!',
    },
    playerCard: {
      more: 'More',
      less: 'Less',
      homeVsAway: '<strong>{{homeTeam}}</strong> vs {{awayTeam}}',
      awayAtHome: '<strong>{{awayTeam}}</strong> @ {{homeTeam}}',
    },
    pickListCompact: {
      columnPlayer: 'Player',
      columnMatchup: 'Matchup',
      columnTrend: 'L5 Games',
      columnLine: 'Stat',
      columnPick: 'More or Less',
    },
    nav: {
      browse: 'Browse',
      myEntries: 'My Entries',
      sportsAndLeagues: 'Sports & Leagues',
      balance: 'Balance',
      promotions: 'Promotions',
    },
    filters: {
      gameModal: {
        title: 'Filter by game',
        allGames: 'All games',
        submit: 'Show Picks',
      },
      searchInputPlaceholder: 'Search',
      allPlayers: 'All Players',
      sortedByMostPopular: 'Sorted by most popular picks',
    },
    boardSearch: {
      sectionAllPlayers: 'All Players',
      morePicksCta: 'More picks',
    },
    maxPicksReachedError: {
      title: 'Max picks reached',
      message: 'Max of {{count}} picks allowed. Remove a pick to add another.',
    },
    popularPicks: {
      title: 'Popular Picks',
      viewAll: 'View all',
      error: {
        title: 'Something went wrong...',
        subtitle: 'Check your network connection or reload the page.',
      },
      empty: {
        title: 'No picks available today',
        subtitle: 'Check back again soon!',
      },
    },
    gamesEvents: {
      title: 'Upcoming Games & Events',
      today: 'Today',
      startsIn: 'Starts in',
      morePicks: 'More picks',
      round: 'Round {{number}}',
      error: {
        title: 'Something went wrong...',
        subtitle: 'Check your network connection or reload the page.',
      },
      empty: {
        title: 'No picks available today',
        subtitle: 'Check back again soon!',
      },
    },

    emptyScreen: {
      noProps: {
        title: 'No picks available yet',
        subtitle: 'Choose another sport or try again later.',
      },
      noPopularProps: {
        title: 'No popular props available yet',
        subtitle: 'Check back later.',
      },
      noSearchResults: {
        title: 'No results found',
        subtitle: 'Try another search.',
      },
    },
    errors: {
      maxEntriesReached: 'Max of {{count}} picks allowed. Remove a pick to add another.',
      notAllowedLocation: 'You might be in a restricted location.',
    },
    samePlayerPrompt: {
      title: 'Only one pick per player',
      subtitle:
        "You've selected the same player twice. Pick the one you want to keep in this entry.",
      confirm: 'Confirm',
      close: 'Close',
      directionMore: 'More',
      directionLess: 'Less',
    },
    payoutTypeSelector: {
      title: 'Game Mode',
      maxPayout: {
        title: 'Top Score',
        description: 'Outscore everyone in your contest to win. Ties split the prize.',
        winUpTo: 'Win up to',
      },
      protectedPayout: {
        title: 'Perfect Score',
        description: 'Go perfect for a guaranteed payout. No prize if you miss a pick.',
        descriptionV2:
          'Go perfect for a guaranteed payout. If no one in your group goes perfect, the prize goes to whoever gets the most correct.',
        guaranteed: 'Guaranteed',
        notAvailable: 'Not Available',
      },
      infoModal: {
        title: 'Game Modes',
        intro:
          'QuickPicks is a peer to peer fantasy contest. Entrants compete against other users, earning one point for every correct pick and half a point for ties. The entrant(s) with the highest score in their contest wins the prize.',
        maxPayout: {
          description:
            'Win your contest for the biggest payout available. Even if you miss picks, you can still win as long as your score is higher than everyone else. If there are multiple winners the prize is split among them.',
        },
        protectedPayout: {
          description:
            'If you get all your picks correct your payout is guaranteed. If you have a tie (push) or a voided pick you will receive a downgraded payout as long as your entry is still valid. For example, a 3-pick entry with one void will payout as a 2-pick entry as long as the remaining players are on two different teams.',
        },
        example: {
          description:
            'Example: You get 3 out of 4 picks correct. Everyone else in your contest gets 2 or fewer picks correct. With the Top Score game mode, you will win the full contest prize.',
        },
      },
    },
  },
  playerCard: {
    otherPicks: 'Other picks',
    picks: 'Picks',
    gameLog: 'Game Log',
    noOtherPicks: 'No other picks',
    error: {
      title: 'Error',
      message: 'There was an error loading this player card. Please refresh and try again.',
      cta: 'Try again',
    },
    lastXAvg: 'LAST {{count}} AVG: ',
    lastXAvgShort: 'L{{count}} AVG: ',
  },
  freeSlot: {
    title: 'Free Slot',
    amount: '+${{amount}}',
  },
  boost: {
    title: 'Boost',
    viewTerms: 'View terms',
    expires: 'Expires:',
    promotions: 'Promotions',
    terms: 'Promotion Terms',
    close: 'Close',
    xBoostsAvailable__hasPlural: {
      one: '1 Available promotion',
      other: '{{count}} Available promotions',
    },
    applyPromo: 'Apply',
    removePromo: 'Remove',
    apply: 'Apply',
    remove: 'Remove',
    applyPromotion: 'Apply promotion',
    removePromotion: 'Remove promotion',
    change: 'Apply a different promo?',
    changeCopy: 'You already have a promotion applied.',
    changeCopy2: 'Would you like to remove that promotion and apply this one?',
    cancel: 'Cancel',
    confirm: 'Confirm',
    viewAll: 'View all',
    riskFree: 'Risk Free',
    riskFreeEntryDetailsCopy: 'Risk Free - {{amount}} refunded as credit.',
    notAvailableWithProtectedPayout: 'Not available with Perfect Score payout.',
    notAvailableWithMaxPayout: 'Not available with Top Score payout.',
  },
  voucher: {
    use: 'Use',
  },
  matchStatus: {
    cancelled: 'Cancelled',
    noMatchFound: 'No match found',
    waitingForMatch: 'Waiting for match',
    matchedWithPercentFull: 'Matched - {{percent}}% full',
    partiallyMatched: 'Partially matched',
  },
  less: 'Less',
  more: 'More',
  matchFound: 'Match found',
  eliminationZone: 'Elimination zone',
  addedFreeSlots: 'Added free slots',
  locationInfo: {
    disallowedSingleStatCopy:
      '{{state}} law requires that each Player Pick is a combination of 2+ stats (Pts + Reb). Single stat categories (Reb.) are unavailable.',
    disallowedSingleStatButton: 'Dismiss',
  },
  XRemaining: '{{count}} remaining',
  matchedContests: 'Matched contests',
  promotionBanner: {
    subheadingPlayer: 'Let your players win',
    subheadingTeam: 'Ride your team to a',
    title: '50x payout!',
    subtitle: 'Entries start at $5',
    button: 'Play QuickPicks',
  },
  standings: {
    payoutChanged: {
      toast: {
        multipleWinners: "Missed a pick? Top Score payout would've still earned you winnings.",
      },
      modal: {
        multipleWinners: {
          title: 'Close call? Top Score game mode rewards ties',
          description:
            'Unlike the Top Score game mode, Perfect Score only pays out for perfect picks.',
        },
        button: 'Got it',
      },
    },
  },
};
